// дефолти для типових hotel-сторінок; інша сторінка передає свої options
const DEFAULT_OPTIONS = {
    triggerElement: '.js-ai-button-trigger',
    overlayElement: '.js-cookie-policy',
};
// кнопка рендериться лише для AB-тесту 509 — для решти чанк не завантажується
const initAiButton = async (options = {}) => {
    const aiButtonElement = document.querySelector('.js-ai-button');
    if (!aiButtonElement)
        return;
    const { default: AiButton } = await import('@resources/js/components/ai-button/AiButton');
    new AiButton(aiButtonElement, Object.assign(Object.assign({}, DEFAULT_OPTIONS), options));
};
export default initAiButton;
